module.exports = __webpack_public_path__ + "img/warning.7a63570d.svg";